import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import Lightbox, { resolveUrl } from "@/components/Lightbox";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SPANS = [
  "col-span-12 md:col-span-7 row-span-2",
  "col-span-6 md:col-span-5",
  "col-span-6 md:col-span-5",
  "col-span-12 md:col-span-4",
  "col-span-6 md:col-span-4",
  "col-span-6 md:col-span-4",
  "col-span-6 md:col-span-6",
  "col-span-6 md:col-span-6",
];

export const PortfolioGrid = ({ limit }) => {
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lightIdx, setLightIdx] = useState(null);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/clients/rotating`, { params: { limit: limit || 60 } });
        if (!cancel) setPhotos(data.photos || []);
      } catch (e) {
        console.error(e);
      } finally {
        if (!cancel) setLoading(false);
      }
    })();
    return () => { cancel = true; };
  }, [limit]);

  const items = limit ? photos.slice(0, limit) : photos;

  if (!loading && items.length === 0) {
    return <div className="text-white/50 font-mono-tech text-sm" data-testid="portfolio-empty">No work published yet.</div>;
  }

  return (
    <div data-testid="portfolio-grid">
      <div className="grid grid-cols-12 auto-rows-[180px] md:auto-rows-[220px] gap-3 md:gap-4">
        <AnimatePresence mode="popLayout">
          {items.map((p, i) => (
            <motion.figure
              layout
              key={`${p.url}-${i}`}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.6, delay: i * 0.05, ease: [0.2, 0.7, 0.2, 1] }}
              className={`group relative overflow-hidden bg-[#0d0d0d] cursor-pointer ${SPANS[i % SPANS.length]}`}
              onClick={() => setLightIdx(i)}
              data-testid={`portfolio-item-${i}`}
            >
              <img
                src={resolveUrl(p.url)}
                alt={p.client || ""}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
              />
              {p.client && (
                <div className="absolute top-3 left-3 z-10 font-mono-tech text-[10px] tracking-[0.2em] uppercase text-white/85 bg-black/45 backdrop-blur px-2 py-1 border border-white/10">
                  {p.client}
                </div>
              )}
            </motion.figure>
          ))}
        </AnimatePresence>
      </div>

      <Lightbox photos={items} index={lightIdx} onClose={() => setLightIdx(null)} onIndex={setLightIdx} />
    </div>
  );
};

export default PortfolioGrid;
